import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../_models';
import { RestService } from './rest.service';
import { AlertService } from './alert.service';
import { StorageService } from './storage/storage.service';
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private CompanyPermissions: BehaviorSubject<any>;
  public CompanyPermission: Observable<any>;

  constructor(private http: HttpClient, private restService: RestService, private alertService: AlertService, private storageService: StorageService) {
    this.currentUserSubject = new BehaviorSubject<User>(this.storageService.getItem('SignIn'));
    this.currentUser = this.currentUserSubject.asObservable();
    this.CompanyPermissions = new BehaviorSubject({});
    this.CompanyPermission = this.CompanyPermissions.asObservable();
  }

  public currentUserObservable(): Observable<User> {
    return this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  signIn(reqData: any) {
    return this.restService.post(reqData).pipe(map((response: any) => {
      if ([200, 632].indexOf(response.ResponseCode) != -1) {
        if (response.ResponseCode == 632) {
          this.storageService.setItem('persistentMessage', response.persistentMessage);
        }
        this.storageService.setItem('SignIn', response.Data);
        localStorage.setItem('accesToken', response.Data.LoginSessionKey);
        this.storageService.setItem('CompanyPreferences', response.Data.CompanyPreferences);
        if (response.EmulatedMode) {
          this.storageService.removeItem('uaInfo');
        }
        this.currentUserSubject.next(response.Data);
        localStorage.setItem('refresh', '1');
        return response;
      } else {
        this.alertService.error(response.Message);
      }
    }));
  }
  signUp(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getCompanyPermissions(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => {
      if (res.ResponseCode == 200) {
        this.CompanyPermissions.next(res.Data);
      } else {
        this.alertService.error(res.Message);
      }
      return res;
    }));
  }
  logout(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => {
      if ([200, 535].indexOf(res.ResponseCode) != -1) {
        this.currentUserSubject.next(null);
        const uaInfo = this.storageService.getItem('uaInfo');
        this.storageService.clear();
        this.storageService.setItem('uaInfo', uaInfo);
      } else {
        this.alertService.error(res.Message);
      }
      return res;
    }));
  }
  checkDomain(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  verifyCode(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  changePassword(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  recoverPassword(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  setData(profilePicture: string) {
    const currentUser = this.currentUserSubject.getValue();
    currentUser.UserDetails.ProfilePicture = profilePicture;
    this.currentUserSubject.next(currentUser);
    this.storageService.setItem('SignIn', currentUser);
  }
  setCurrentUserData(currentUser: any) {
    this.currentUserSubject.next(currentUser);
    this.storageService.setItem('SignIn', currentUser);
  }
  GetUserProfile(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  EditCompanyUser(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  BlockCompanyUser(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  RestorePassword(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  UpdateLenderProfile(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetSyndicateData(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetCompanyPreferences(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  InviteBuyerAssociate(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
}